const FormRepRadio = ({question, handleChange, handleClick}) => {
	
  if(question.type_rep !== 'radio') {return ''}
  return <div className='active'>
		{question.reps.length === 2 && <>
			Pré-remplir les réponses : 
		  	<span type="button" className="btn_param" title="Vrai/Faux" onClick={handleClick}>Vrai/Faux</span>
		  	<span type="button" className="btn_param" title="Oui/Non" onClick={handleClick}>Oui/Non</span>
			<br/><br/>
				  </>}
		La première réponse doit-être la bonne réponse attendue.<br/><br/>
			  {question.reps.map((rep, k) => 
			    <label key={k}>
			      <input type="radio" /> <input type="text" name={"rep"+(k+1)} id="reps" value={question.reps[k] === 'Réponse '+(k+1) || question.reps[k] === 'Nouvelle réponse' ? '' : question.reps[k]} onChange={handleChange} placeholder={rep+(k===0?' (la bonne)' : '')} /> 
			      <br/>
			    </label>
			   )}
			  <input type="button" className="btn standard" style={{width:"35%"}} value="Ajouter un champ" onClick={handleClick} />
			  <input type="button" className="btn standard" style={{width:"35%"}} value="Supprimer un champ" onClick={handleClick} /><br/>
		  </div>
}

const FormRepCheckbox = ({question, handleChange, handleClick}) => {

	if(question.type_rep !== 'checkbox') {return ''}
	  return <div className='active'>
	    Les premières réponses seront les réponses correctes<br/>
	    Nb bonnes réponses : <input type="number" min="0" max="10" name="nb_bonnes_rep" value={question.nb_bonnes_rep} onChange={handleChange} size="3"/><br/>
	    {question.reps.map((rep, k) => 
	      <label key={k}>
	        <input type="checkbox" /> <input type="text" name={"box"+(k+1)} value={question.reps[k] === 'Réponse '+(k+1) || question.reps[k] === 'Nouvelle réponse' ? '' : question.reps[k]} onChange={handleChange} id="reps" placeholder={rep} /> 
	        <br/>
	      </label>
	     )}
	    <input type="button" className="btn standard" style={{width:"35%"}} value="Ajouter un champ" onClick={handleClick} />
	    <input type="button" className="btn standard" style={{width:"35%"}} value="Supprimer un champ" onClick={handleClick} />
	  </div>
}

const FormRepField = ({question, handleChange}) => {
	if(question.type_rep !== 'field') {return ''}
	return <textarea 
				name="field" 
				className="text" 
				onChange={handleChange} 
				value={question.field}
				cols="30" rows="6" 
				placeholder="Réponse avec le champ entouré du symbole _&#13;Si plusieurs réponses possibles, les séparer par trois points ...&#13;Ex : _5/2...2,5_ si la question est « 10/4 se simplifie en »">
			</textarea>
}

export function FormTypeRep ({question, setQuestion, handleChange}) {

	const handleClick = (e) => {
		let name =''
		let val = ''
		if(e.target.value === 'Ajouter un champ'){
	      name = 'reps'
	      val = [...question.reps, 'Nouvelle réponse']
	    }
	    if(e.target.value === 'Supprimer un champ'){
	      if(question.reps.length > 2) {
	        name = 'reps'
	        val = question.reps.slice(0,-1)
	      }
	    }
	    if(e.target.title === 'Oui/Non' && question.reps.length === 2){
	        name = 'reps'
	        val = question.reps[0] === 'Oui' ? ['Non', 'Oui'] : ['Oui', 'Non']
	    }
	    if(e.target.title === 'Vrai/Faux' && question.reps.length === 2){
	        name = 'reps'
	        val = question.reps[0] === 'Vrai' ? ['Faux', 'Vrai'] : ['Vrai', 'Faux']
	    }
	    setQuestion({...question, [name]:val})
	}

	let typeReps = [
	    ['rep_type_radio', 'Réponse type QCM à une seule bonne réponse', 'type QCM', 'radio'],
	    ['rep_type_checkbox', 'Réponse type QCM à plusieurs bonnes réponses', 'type QCM multi', 'checkbox'],
	    ['rep_type_champ', 'Réponse type champ', 'type champ', 'field'],
	]

	return (
		<span>
			<b>Type de réponse attendu :</b><br/>
			{typeReps.map((e,k)=> 
        <span key={k} name={e[3]} className={'btn_param' + (question.type_rep === e[3] ? ' active': '')} title={e[1]} onClick={() => setQuestion({...question, type_rep:e[3], reps:['Réponse 1', 'Réponse 2']})}>{e[2]}</span>)}
		<br/><br/>
		<FormRepRadio question={question} handleChange={handleChange} setQuestion={setQuestion} handleClick={handleClick} />
		<FormRepCheckbox question={question} handleChange={handleChange} setQuestion={setQuestion} handleClick={handleClick} />
		<FormRepField question={question} handleChange={handleChange} />
		</span>
	);
}